import { render, staticRenderFns } from "./setupaccount.vue?vue&type=template&id=6e47204c&scoped=true"
import script from "./setupaccount.vue?vue&type=script&lang=js"
export * from "./setupaccount.vue?vue&type=script&lang=js"
import style0 from "./setupaccount.vue?vue&type=style&index=0&id=6e47204c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e47204c",
  null
  
)

export default component.exports